<template>
  <base-property-icon-item :label="label">
    <template v-slot:icon>
      <parking-icon></parking-icon>
    </template>
  </base-property-icon-item>
</template>
<script>
import BasePropertyIconItem from './BasePropertyIconItem.vue';
import ParkingIcon from '../Icons/ParkingIcon.vue';
export default {
  props: ['label'],
  components: {
    BasePropertyIconItem,
    ParkingIcon,
  },
};
</script>
